import { GlobalState } from "@/Reducers/interface";
import React, { forwardRef } from "react";
import { useSelector } from "react-redux";
import ZSelect from "@atoms/ZSelect";
import {
	IOptionProps,
	ISelectProps
} from "@atoms/ZSelect/interface";
import { RefSelectProps } from "antd/lib/select";

const TaxSelect = forwardRef<
	React.RefObject<RefSelectProps>,
	ISelectProps<string>
>((props, ref) => {
	const selectRef = ref as React.RefObject<RefSelectProps>;

	const taxCategories = useSelector(
		(state: GlobalState) => state.user.taxCategoriesList
	);

	const selectOptions = taxCategories
		.filter(category => !category.disabled)
		.map<IOptionProps>(category => ({
			name: category.disabled
				? `${category.name} (Disabled)`
				: category.name,
			value: category.id,
			disabled: category.disabled
		}));

	return (
		<ZSelect
			{...props}
			zref={selectRef}
			selectOptions={selectOptions}
			placeholder={props.placeholder ?? "Select a tax category"}
			data-testid="tax-select"
		/>
	);
});

export default TaxSelect;
